<template>
  <div v-if="reviews.length" class="mb-8">
    <div v-for="review in reviewsToShow" :key="review.id" class="mb-10">
      <div>
        <div class="mb-6 inline-block font-medium text-gray-dark md:text-xl">
          <img
            loading="lazy"
            :src="review.publication_icon"
            width="24"
            height="24"
            class="-mt-1 mr-1 inline-block w-6 bg-gray-400 align-middle"
            :alt="review.publication_name"
          >
          {{ review.publication_name }}
        </div>

        <div v-if="review.display_rating" class="mb-2 ml-4 inline-block rounded-sm border border-lime3 px-2 text-sm text-body md:text-lg">
          <span v-if="ratingType(review) === 'other'" class="inline-block">
            {{ review.display_rating }}
          </span>

          <span v-if="ratingType(review) === 'stars'" class="-mt-1 inline-block align-middle">
            <StarRating :stars="getStars(review)" />
          </span>

          <span v-if="ratingType(review) === 'checkmark'" class="inline-block">
            <span class="inline-block align-middle">
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.81505L4.77097 9.10607L0 4.82146L0.843298 3.82072L4.69013 7.34375L11.0685 0.893921L12 1.81505Z" fill="#4D4D4D" />
              </svg>
            </span>
            <span class="text-base">{{ review.display_rating.replace(/\[checkmark\]/i, '') }}</span>
          </span>
        </div>
      </div>

      <div class="mb-3 text-body md:text-xl">
        "{{ review.extract }}"
        <span v-if="review.source_url && !review.publication_article">
          <a class="underline hover:text-black" :href="review.source_url" target="_blank" rel="noopener noreferrer">Full review</a>
        </span>
      </div>
      <div v-if="review.publication_article" class="text-body">
        <a class="mb-2 font-semibold underline hover:text-gray-800" :href="review.source_url" target="_blank" rel="noopener noreferrer">
          {{ review.publication_article.title }}
        </a>
        <div>
          {{ $f.date(review.publication_article.date_published, 'MMMM D, YYYY') }}
        </div>
      </div>
      <div v-if="review.advice" class="my-4 flex">
        <div class="mr-3 size-5 rounded-full bg-lime2 px-2 text-sm font-bold">
          i
        </div>
        <div class="font-bold italic text-gray-2">
          {{ review.advice }}
        </div>
      </div>
    </div>

    <template v-if="showAllReviews">
      <a
        v-if="reviews.length > limit && !showReviews"
        href="#"
        class="letter-sp15 inline-block rounded border border-gray-dark px-4 py-3 uppercase text-gray-dark hover:bg-gray-200"
        @click.prevent="showReviews = true"
      >
        Show All Reviews
      </a>
    </template>
  </div>
</template>

<script>
import StarRating from '~/components/shared/StarRating'

export default {
  components: { StarRating },

  props: {
    reviews: { type: Array, required: true },
    showAllReviews: { type: Boolean, default: true },
    startFrom: { type: Number, default: 0 },
  },

  data: () => {
    return {
      showReviews: false,
    }
  },

  computed: {
    reviewsToShow () {
      if (! this.showReviews) {
        return this.reviews.slice(this.startFrom, this.limit)
      }

      return this.reviews.filter((e, i) => i >= this.startFrom)
    },

    limit () {
      return this.startFrom + 10
    },
  },

  methods: {
    ratingType (review) {
      if (! review.display_rating) {
        return 'none'
      }
      if (review.display_rating.match(/\[checkmark]/i)) {
        return 'checkmark'
      }
      if (review.display_rating.match(/(\[star])|(\[empty-star])|(\[half-star])/i)) {
        return 'stars'
      }
      return 'other'
    },

    getStars (review) {
      if (! review.display_rating || ! review.display_rating.matchAll) { return [] }
      return Array.from(review.display_rating.matchAll(/\[([a-z-]+)\]/ig)).map((m) => {
        switch (m[1]) {
          case 'empty-star': return 'empty'
          case 'star': return 'full'
          case 'half-star': return 'half'
        }
        return null
      })
    },
  },
}
</script>
